export default __webpack_public_path__ + "assets/broccoloni.34a299cc.webp";